<script>
  import { onMount } from "svelte"
  import { sanitizePastedText } from "./utils/sanitize.js"

  export let text
  export let focused

  let root

  function onPaste(event) {
    event.preventDefault()
    const paste = event.clipboardData.getData("text/plain")
    document.execCommand("insertHTML", false, sanitizePastedText(paste))
  }

  onMount(() => {
    if (focused) root.focus()
  })
</script>

<div
  contenteditable
  spellcheck="false"
  autocomplete="off"
  bind:this={root}
  bind:innerHTML={text}
  on:paste={onPaste}
>
  {text}
</div>

<style>
  div {
    display: block;
    white-space: normal;
    word-wrap: initial;
    -webkit-nbsp-mode: initial;
    cursor: text;
    word-break: break-word;
    line-height: 1em;
  }

  div:focus {
    outline: 0;
  }

  div:empty {
    padding: 0 0.1em;
  }
</style>
